export default {
    data () {
        return {
            field_crs_label: {
                "EPSG:4326": "WGS84 (GPS)",
                "EPSG:28992": "Amersfoort RD New (Rijksdriehoekscoördinaten)",
            },
        }
    },
};